//
//
//
//
//
//
//
//
//
//
//
import WhyExtraItem from './WhyExtraItem';
export default {
  name: 'WhyExtra',
  components: {
    WhyExtraItem
  },

  data() {
    return {
      whyExtraItems: [{
        id: 'why-extra-item-1',
        title: 'Every purchase builds your credit history.',
        videoUrl: 'https://s3.extra.app/site-assets/lander/Comp-1-2.mp4',
        text: 'At the end of every month, purchases made with the Extra debit card are tallied up and reported to credit bureaus to help build your credit.'
      }, {
        id: 'why-extra-item-2',
        title: 'Earns points everywhere you swipe.',
        videoUrl: 'https://s3.extra.app/site-assets/lander/Comp-3-2.mp4',
        text: 'Earn up to 1% in points for everyday purchases like rideshares, coffees and even your phone bills. Spend your points on everything from AirPods to gift cards in our rewards store.'
      }, {
        id: 'why-extra-item-3',
        title: 'Connects to your existing bank account.',
        videoUrl: 'https://s3.extra.app/site-assets/lander/Comp-2-2.mp4',
        text: 'Extra is compatible with over 10,000 banks across the United States—keep your money where you want, while spending smarter with Extra.'
      }]
    };
  }

};